/**
 * Shared text-list helpers used by the Phase 5 meal-plan editor.
 * Centralised so every dishes-textarea behaves identically.
 *
 * IMPORTANT: `textToArr` must NOT trim each line on every keystroke. Doing
 * so eats spaces while the user is typing (e.g. pressing space after
 * "Smoked" would immediately strip the trailing space, so the next
 * character lands flush against "Smoked" → "SmokedSalmon" instead of
 * "Smoked Salmon"). Empty lines are still filtered so they don't survive
 * a save round-trip, but internal and trailing whitespace is preserved
 * while typing. The backend Pydantic validators trim & filter at save
 * time anyway.
 */
export const arrToText = (a) => (Array.isArray(a) ? a : []).join("\n");

export const textToArr = (t) =>
  (t || "")
    .split(/\r?\n/)
    .filter((s) => s.trim().length > 0);
